<template>
  <flex :justify="isMobile ? 'center' : 'end'">
    <div class="pagination">
      <button>
        <img src="../../../assets/images/icons/chevron-left.svg" alt="">
      </button>
      <ul>
        <li v-for="page in last" :key="page">
          <a href="javascript:void(0)" :class="{'selected': page === current}" @click="$emit('click', page)">{{ page }}</a>
        </li>
      </ul>
      <button>
        <img src="../../../assets/images/icons/chevron-right.svg" alt="">
      </button>
    </div>
  </flex>
</template>

<script>
import Flex from '../flex'

export default {
  name: 'pagination',
  components: {Flex},
  props: {
    current: Number,
    last: Number,
  },
  computed: {
    isMobile () {
      return document.documentElement.clientWidth < 991
    }
  }
}
</script>

<style scoped lang="scss">
.pagination {
  display: flex;
  align-items: center;
  margin: 0 -10px;

  button {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background-color: transparent;
    cursor: pointer;
    margin: 0 10px;
  }

  ul {
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0 -5px;

    li {
      margin: 0 5px;
    }

    li a {
      font-family: "Open Sans", sans-serif;
      text-decoration: none;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #DBBFA7;
      background-color: #fff;
      box-sizing: border-box;
      border-radius: 5px;
      width: 40px;
      height: 40px;
      font-size: 20px;
      color: #DBBFA7;

      &.selected {
        font-weight: 600;
        color: #B9765B;
      }
    }
  }
}
</style>
